import "./userDrawer.css";

import { Alert, Button } from "reactstrap";

import PropTypes from "prop-types";
import React from "react";
import { CfSelect as Select } from "../components/CfSelect";
// Side drawer to create or edit a user's information (replaces the old modal).
class UserDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.lastname = React.createRef();
    this.firstname = React.createRef();
    this.phone = React.createRef();
    this.email = React.createRef();

    this.state = {
      companySelected: this.props.user?.company?.id ?? "",
      companyMissing: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    // Reset the form and focus the first field each time the drawer opens.
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        companySelected: this.props.user?.company?.id ?? "",
        companyMissing: false,
      });
      this.lastname.current?.focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(event) {
    if (event.key === "Escape" && this.props.isOpen) this.props.onClose();
  }

  handleSubmit(event) {
    event.preventDefault();
    // A user without a company breaks downstream, so submitting is blocked
    // here, with our own message under the field rather than the browser's.
    if (!this.state.companySelected) {
      this.setState({ companyMissing: true });
      return;
    }
    const user = {
      id: this.props.user.id,
      lastname: this.lastname.current.value,
      firstname: this.firstname.current.value,
      phone: this.phone.current.value,
      email: this.email.current.value,
      company_id: this.state.companySelected,
    };
    if (!this.props.user.id) user.access = true;
    this.props.onSubmit(user);
  }

  render() {
    if (!this.props.isOpen) return null;
    const isCreate = !this.props.user.id;
    const companyOptions = this.props.companies.all.map((company) => ({
      value: company.id,
      label: company.name,
    }));

    return (
      <>
        <div className="user-drawer__backdrop" onClick={this.props.onClose} />
        <div className="user-drawer" role="dialog" aria-label="User form">
          <div className="user-drawer__header">
            <span>{isCreate ? "Create user" : "Update user"}</span>
            <button
              type="button"
              className="user-drawer__close"
              onClick={this.props.onClose}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <form
            id="userForm"
            className="user-drawer__body"
            onSubmit={this.handleSubmit}
          >
            {this.props.alert !== "" && (
              <Alert color="danger">{this.props.alert}</Alert>
            )}

            <div className="user-drawer__field">
              <label className="user-drawer__label">Last name *</label>
              <input
                className="form-control"
                defaultValue={this.props.user.lastname}
                type="text"
                ref={this.lastname}
                required
              />
            </div>

            <div className="user-drawer__field">
              <label className="user-drawer__label">First name</label>
              <input
                className="form-control"
                defaultValue={this.props.user.firstname}
                type="text"
                ref={this.firstname}
              />
            </div>

            <div className="user-drawer__field">
              <label className="user-drawer__label">Company *</label>
              <Select
                options={companyOptions}
                // Compared as strings, the way <option> matching did.
                value={
                  companyOptions.find(
                    (option) =>
                      String(option.value) ===
                      String(this.state.companySelected)
                  ) ?? null
                }
                onChange={(option) =>
                  this.setState({
                    companySelected: option.value,
                    companyMissing: false,
                  })
                }
                placeholder="--Unset--"
                aria-label="Company"
              />
              {this.state.companyMissing && (
                <div className="text-danger small mt-1">
                  A company is required.
                </div>
              )}
            </div>

            <div className="user-drawer__field">
              <label className="user-drawer__label">Phone</label>
              <input
                className="form-control"
                defaultValue={this.props.user.phone}
                type="tel"
                pattern="\+?\d+"
                ref={this.phone}
              />
            </div>

            <div className="user-drawer__field">
              <label className="user-drawer__label">Email *</label>
              <input
                className="form-control"
                defaultValue={this.props.user.email}
                type="email"
                ref={this.email}
                required
              />
            </div>
          </form>

          <div className="user-drawer__footer">
            <Button color="secondary" onClick={this.props.onClose}>
              Cancel
            </Button>
            <Button color="primary" type="submit" form="userForm">
              {isCreate ? "Create" : "Update"}
            </Button>
          </div>
        </div>
      </>
    );
  }
}

UserDrawer.propTypes = {
  alert: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  companies: PropTypes.object.isRequired,
};

export default UserDrawer;
